import { render, staticRenderFns } from "./tongue-folder.vue?vue&type=template&id=8b3a8b80&"
import script from "./tongue-folder.vue?vue&type=script&lang=ts&"
export * from "./tongue-folder.vue?vue&type=script&lang=ts&"
import style0 from "./tongue-folder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports